const middlewares = {
	layout: {
		button: {
			"with-subscription": "Abonnement wijzigen",
			"without-subscription": "Abonnement wijzigen",
		},
	},
	"multiple-companies": {
		title: "Vestigingen",
		heading: "Je hebt een premium abonnement nodig voor deze functie",
		description:
			"Om gebruik te maken van meerdere vestigingen dien je een <1>Premium</1> abonnement te hebben.",
	},
	network: {
		title: "Connections",
		heading: "Je hebt een premium abonnement nodig voor deze functie",
		description:
			"Om gebruik te maken van meerdere vestigingen dien je een <1>Premium</1> abonnement te hebben.",
	},
	"no-subscription": {
		title: "Helaas, je hebt nog geen abonnement!",
		description:
			"Om gebruik te kunnen maken van {{tenant.name}} heb je een actief abonnement nodig. Deze kan je gelukkig in een paar kleine stappen al aanmaken.",
		button: "Abonnement kiezen",
	},
};

export default middlewares;
